<template>
  <FixedBottomBar :has-set-min-width="false" class="revision-bottom-prompt">
    <template #content>
      <div class="text-container">
        <FriedH4>{{ t('files_hang_in_there,_we_are_uploading_your_files!') }}</FriedH4>
        <FriedParagraph>
          {{ t('files_uploading') }}
          {{ filesUploaded }} / {{ totalFilesToUpload }}
          {{ t('files') }}
        </FriedParagraph>
      </div>
    </template>
    <template #actions>
      <FriedSpinner class="button-loader-icon" :aria-label="t('loading')" :size="32" />
    </template>
  </FixedBottomBar>
</template>

<script lang="ts">
import FixedBottomBar from '@getaccept/lib-shared-new/src/components/FixedBottomBar.vue';
import { useI18n } from 'vue-i18n';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {
    FixedBottomBar,
  },
  props: {
    totalFilesToUpload: {
      type: Number,
      default: 0,
    },
    filesUploaded: {
      type: Number,
      default: 0,
    },
  },
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  },
});
</script>
<style lang="scss" scoped>
.heading-4 {
  white-space: nowrap;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
